function cov_22h1jwvp4i() {
  var path = "/app/src/utils/get-source-plugin.ts";
  var hash = "943796c118af9047d6f951a3649f1a5a88ff31c5";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/get-source-plugin.ts",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 31
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "1": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 44,
          column: 3
        }
      },
      "2": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 23
        }
      },
      "3": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 26,
          column: 19
        }
      },
      "4": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 19
        }
      },
      "5": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 21
        }
      },
      "6": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 24
        }
      },
      "7": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 24
        }
      },
      "8": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 23
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 31
          },
          end: {
            line: 21,
            column: 32
          }
        },
        loc: {
          start: {
            line: 21,
            column: 63
          },
          end: {
            line: 45,
            column: 1
          }
        },
        line: 21
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 44,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 23,
            column: 4
          },
          end: {
            line: 24,
            column: 23
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 26,
            column: 19
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 28,
            column: 19
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 30,
            column: 21
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 34,
            column: 24
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 41,
            column: 24
          }
        }, {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 43,
            column: 23
          }
        }],
        line: 22
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 29,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 29,
            column: 12
          },
          end: {
            line: 29,
            column: 24
          }
        }, {
          start: {
            line: 29,
            column: 28
          },
          end: {
            line: 29,
            column: 40
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 32,
            column: 21
          }
        }, {
          start: {
            line: 32,
            column: 25
          },
          end: {
            line: 32,
            column: 76
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 39,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 36,
            column: 17
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 37,
            column: 21
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 38,
            column: 24
          }
        }, {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 39,
            column: 24
          }
        }],
        line: 36
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0, 0, 0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "943796c118af9047d6f951a3649f1a5a88ff31c5"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_22h1jwvp4i = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_22h1jwvp4i();
cov_22h1jwvp4i().s[0]++;
export var getSourcePlugin = function getSourcePlugin() {
  var _window$checkout;
  cov_22h1jwvp4i().f[0]++;
  cov_22h1jwvp4i().s[1]++;
  switch (true) {
    case !!window.Shopify:
      cov_22h1jwvp4i().b[0][0]++;
      cov_22h1jwvp4i().s[2]++;
      return 'shopify';
    case !!window.woocommerce_params:
      cov_22h1jwvp4i().b[0][1]++;
      cov_22h1jwvp4i().s[3]++;
      return 'woo';
    case !!window.zid:
      cov_22h1jwvp4i().b[0][2]++;
      cov_22h1jwvp4i().s[4]++;
      return 'zid';
    case !!((cov_22h1jwvp4i().b[1][0]++, window.salla) || (cov_22h1jwvp4i().b[1][1]++, window.Salla)):
      cov_22h1jwvp4i().b[0][3]++;
      cov_22h1jwvp4i().s[5]++;
      return 'salla';
    case !!((cov_22h1jwvp4i().b[2][0]++, window.checkout) && (cov_22h1jwvp4i().b[2][1]++, (_window$checkout = window.checkout) !== null && _window$checkout !== void 0 && (_window$checkout = _window$checkout.imageTemplate) !== null && _window$checkout !== void 0 && _window$checkout.includes('Magento'))):
      cov_22h1jwvp4i().b[0][4]++;
      cov_22h1jwvp4i().s[6]++;
      return 'magento2';
    case !!((cov_22h1jwvp4i().b[3][0]++, window.cart) && (cov_22h1jwvp4i().b[3][1]++, window.cart.add) && (cov_22h1jwvp4i().b[3][2]++, window.cart.update) && (cov_22h1jwvp4i().b[3][3]++, window.cart.remove)):
      cov_22h1jwvp4i().b[0][5]++;
      cov_22h1jwvp4i().s[7]++;
      return 'opencart';
    default:
      cov_22h1jwvp4i().b[0][6]++;
      cov_22h1jwvp4i().s[8]++;
      return undefined;
  }
};